var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 7C11.5791 7 11.4 7.1722 11.4 7.38462C11.4 7.59703 11.5791 7.76923 11.8 7.76923H15.8C16.0209 7.76923 16.2 7.94143 16.2 8.15385V15.8462C16.2 16.0586 16.0209 16.2308 15.8 16.2308H11.8C11.5791 16.2308 11.4 16.403 11.4 16.6154C11.4 16.8278 11.5791 17 11.8 17H15.8C16.4627 17 17 16.4834 17 15.8462V8.15385C17 7.51659 16.4627 7 15.8 7H11.8Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.3846C13.2209 12.3846 13.4 12.2124 13.4 12C13.4 11.7876 13.2209 11.6154 13 11.6154H8.36569L10.0828 9.96427C10.2391 9.81407 10.2391 9.57055 10.0828 9.42034C9.92663 9.27014 9.67337 9.27014 9.51716 9.42034L7.11716 11.728C6.96095 11.8782 6.96095 12.1218 7.11716 12.272L9.51716 14.5797C9.67337 14.7299 9.92663 14.7299 10.0828 14.5797C10.2391 14.4295 10.2391 14.1859 10.0828 14.0357L8.36569 12.3846H13Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.8f401dee1d0fdab6bd410aa266542a1d.svg";
export { ForwardRef as ReactComponent };